import { render, staticRenderFns } from "./trade-filters-top.vue?vue&type=template&id=c4f16d7a&scoped=true&"
import script from "./trade-filters-top.vue?vue&type=script&lang=js&"
export * from "./trade-filters-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f16d7a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VCol,VContainer,VIcon,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4f16d7a')) {
      api.createRecord('c4f16d7a', component.options)
    } else {
      api.reload('c4f16d7a', component.options)
    }
    module.hot.accept("./trade-filters-top.vue?vue&type=template&id=c4f16d7a&scoped=true&", function () {
      api.rerender('c4f16d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/trade-filters-top.vue"
export default component.exports